export const SEND = 'send';
export const CLOSE = 'close';
